import type { NavigateFunction } from "react-router-dom";

import type { useCurrentUser } from "hooks/api/use-current-user";
import { AdminSidebarContent } from "./admin-sidebar-content";
import { ClientUserSidebarContent } from "./client-user-sidebar-content";

type AppSidebarCurrentUser = ReturnType<typeof useCurrentUser>;

type AppSidebarNavigationProps = {
  isClientUser: boolean;
  pathname: string;
  navigate: NavigateFunction;
  currentUser: AppSidebarCurrentUser;
};

export const AppSidebarNavigation = ({
  isClientUser,
  pathname,
  navigate,
  currentUser,
}: AppSidebarNavigationProps) => {
  if (isClientUser) {
    return <ClientUserSidebarContent pathname={pathname} />;
  }

  return <AdminSidebarContent pathname={pathname} navigate={navigate} currentUser={currentUser} />;
};
